import KanbanPage from "../../../components/kanban";

const KanbanComponent = (props: any) => {
    return (
        <KanbanPage persona="PARTNERSHIP" {...props} />
    );
};

const MaintenanceMonitoring = (props: any) => {
    return <KanbanComponent {...props} />;
};

export default MaintenanceMonitoring;